import React from 'react';

// MUI
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// components
import Button from 'components/v2/FormElements/Button';

const Root = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(2),
}));

const Header = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  background: theme.palette.backgroundBasic.main,
  borderRadius: 10,
  marginLeft: -10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const TitleContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

const StyledTitle = styled(Typography)(({ theme }) => ({
  paddingLeft: 10,
  color: theme.palette.info.dark,
  fontSize: 16,
  fontWeight: 500,
}));

const StyledSubtitle = styled(Typography)({
  display: 'block',
});

const StyledCaption = styled(Typography)({
  fontStyle: 'italic',
  fontSize: '0.75rem',
  paddingRight: 5,
  maxWidth: '60%',
  alignItems: 'center',
  display: 'contents',
});

const StyledIcon = styled('div')(({ theme }) => ({
  color: theme.palette.info.dark,
  width: 32,
  height: 32,
}));

// generally there should only be an onClick or caption and not both
const Section = ({
  title,
  subtitle,
  Icon,
  ActionItem,
  children,
  caption,
  CaptionIcon = null,
  permission = true,
  onClick,
  clickText = 'Edit',
}) => {
  if (!permission) return null;

  return (
    <Root>
      <Header display="flex" alignItems="center" justifyContent="flex-start">
        <TitleContainer>
          {Icon && <StyledIcon as={Icon} />}
          <StyledTitle variant="h3" component="span">
            {title}
            {subtitle && (
              <StyledSubtitle variant="caption" component="span">
                {subtitle}
              </StyledSubtitle>
            )}
          </StyledTitle>
        </TitleContainer>
        {caption && (
          <Box display="flex">
            {CaptionIcon && <CaptionIcon />}
            <StyledCaption variant="caption">{caption}</StyledCaption>
          </Box>
        )}
        {onClick && (
          <Button onClick={onClick} size="small">
            {clickText}
          </Button>
        )}
        {ActionItem && <ActionItem />}
      </Header>
      <div>{children}</div>
    </Root>
  );
};

export default Section;
